module.exports = __webpack_public_path__ + "a553d5d5329e70f6699f556e7ac5cfe6.svg";